module.exports = __webpack_public_path__ + "img/logo_twitter.8a441bc7.png";